

import { DEFAULT_CONTRACT_ID } from '../const/AppConst';
import {
  INomenclature,
  IPropositionDetails,
  IConsent,
  IBeneficiaryAdditionReq,
  IPreContractDocument,
  IUploadedDocument,
  IExtractedSecurityInfo,
  IExtractedRibInfo,
  IUpdatedProposition,
  ISignContract,
  IValidEmail,
  IDqeAdresseData,
  IModificationDataAfterSignature,
  IUpdatedStepRequest,
  IPropositionCart,
  IOffers,
  IRequestDataCreateRetirementProposition,
  IOldCompetitor,
  IRERequestDataOffers,
  IOffersDetails,
  ISimulateOffers,
  ISubscriptionInfo,
  ISubscriptionAccessCode,
  ISubscriptionConfirmEmailCode,
  ISubscriptionInfoV2,
  ISubscriptionSendLinkData,
  ISubscriptionSendLinkCreateAccountData
} from '../context/model';
import { authApi, collectiveAffiliationApi, collectiveAffiliationApiWithoutToken, collectiveAffiliationApiWithoutTokenV2, tarificationApi, toolApi } from './BaseApiService';



export function getNomenclature(jwt: string, id: string) {
  return toolApi(jwt).get<INomenclature>(`/nomenclatures/${id}`);
}

export function getConcurrents(jwt: string){
  return toolApi(jwt).get<IOldCompetitor[]>(`/concurrents`);

}
export function getPropositionById(jwt: string, id: string) {
  return collectiveAffiliationApi(jwt).get<IPropositionDetails>(`/propositions/${id}`);
}

export function getPropositionCart(jwt: string, id: string) {
  return collectiveAffiliationApi(jwt).get<IPropositionCart>(`/propositions/${id}/subscriptions/cart`);
}

export function updatePropositionStep(jwt: string, id: string, data: IUpdatedStepRequest) {
  return collectiveAffiliationApi(jwt).patch(`/propositions/${id}/subscriptions/step`, data);
}

export function initSubscription(jwt: string, id: string) {
  return collectiveAffiliationApi(jwt).post(`/propositions/${id}/subscriptions/init`);
}
export function startSubscription(jwt: string, id: string) {
  return collectiveAffiliationApi(jwt).post(`/propositions/${id}/subscriptions/start`);
}
export function updatePropositionContact(jwt: string, id: string, data: IUpdatedProposition) {
  return collectiveAffiliationApi(jwt).patch<IPropositionDetails>(`/propositions/${id}/contact`, data);
}

export function lockProposition(jwt: string, id: string, data: IUpdatedProposition) {
  return collectiveAffiliationApi(jwt).post<IPropositionDetails>(`/propositions/${id}/subscriptions/lock`, data);
}

export function createPropositionConsent(jwt: string, id: string, data: IConsent) {
  return collectiveAffiliationApi(jwt).post<IConsent>(`/propositions/${id}/consents`, data);
}


export function addBeneficiary(jwt: string, id: string, data: IBeneficiaryAdditionReq) {
  return collectiveAffiliationApi(jwt).post<IConsent>(`/propositions/${id}/beneficiaries/add`, data);
}
export function getListOfDocumentsByProposition(jwt: string, id: string) {
  return collectiveAffiliationApi(jwt).get<IPropositionDetails>(`/propositions/${id}/document-types/`);
}

export function validateSubscription(jwt: string, id: string) {
  return collectiveAffiliationApi(jwt).post(`/propositions/${id}/subscriptions/validate`);
}

export function uploadSocialSecurity(jwt: string, id: string, attestationSecu: File, toExtract = true, isPrincipleContact: boolean, toNotify = false, eventId?: string ) {
  const formData = new FormData();
  formData.append('file', attestationSecu);

  const headers = {
    'Content-Type': 'multipart/form-data'
  };

  let url = `/propositions/${id}/documents/social-security-docai?toExtract=${toExtract}&isPrincipleContact=${isPrincipleContact}&toNotify=${toNotify}`;
  if(eventId) {
    url+=`&eventId=${eventId}`;
  }
  return collectiveAffiliationApi(jwt).post<IUploadedDocument<IExtractedSecurityInfo>>(url, formData, {headers});
}

export function uploadRib(jwt: string, id: string, rib: File, toExtract = true, toNotify = false, eventId?: string ) {
  const formData = new FormData();
  formData.append('file', rib);

  const headers = {
    'Content-Type': 'multipart/form-data'
  };

  let url = `/propositions/${id}/documents/rib-docai?toExtract=${toExtract}&toNotify=${toNotify}`;
  if(eventId) {
    url+=`&eventId=${eventId}`;
  }
  return collectiveAffiliationApi(jwt).post<IUploadedDocument<IExtractedRibInfo>>(url, formData, {headers});
}

export function uploadIdentityDocument(jwt: string, id: string, identity: File, backSideFile: File | null, type: string | null,toExtract = true, toNotify = false, eventId?: string) {
  const formData = new FormData();
  formData.append('file', identity);
  if (backSideFile) {
    formData.append('backSideFile', backSideFile);
  };
 
  const headers = {
    'Content-Type': 'multipart/form-data'
  };

  let url = `/propositions/${id}/documents/identity/${type}?toExtract=${toExtract}&toNotify=${toNotify}`;
  if(eventId) {
    url+=`&eventId=${eventId}`;
  }
  return collectiveAffiliationApi(jwt).post(url, formData, {headers});
}

export function uploadFamilyDocument(jwt: string, id: string, document: File, type: string, toNotify = false, eventId?: string) {
  const formData = new FormData();
  formData.append('file', document);

  const headers = {
    'Content-Type': 'multipart/form-data'
  };

  let url = `/propositions/${id}/documents/family/${type}?toNotify=${toNotify}`;
  if(eventId) {
    url+=`&eventId=${eventId}`;
  }
  return collectiveAffiliationApi(jwt).post(url, formData, {headers});
}

export function listPreContractDocuments(jwt: string, id: string) {
  return collectiveAffiliationApi(jwt).get<IPreContractDocument[]>(`propositions/${id}/pre-contract-documents`);
}

export function downloadPreContractDocument(jwt: string, id: string, preContractDocument: IPreContractDocument) {
  return collectiveAffiliationApi(jwt, 'application/octet-stream').post<any>(`propositions/${id}/pre-contract-documents`, preContractDocument, {
    responseType: 'arraybuffer'
  });
}

export function downloadUploadedDocument(jwt: string, id: string, documentId: string | undefined) {
  return collectiveAffiliationApi(jwt, 'application/octet-stream').get<any>(`propositions/${id}/documents/${documentId}`, {
    responseType: 'arraybuffer'
  });
}

export function initSmsSignatureCode(jwt: string, id: string, phone: string) {
  return collectiveAffiliationApi(jwt).post(`/propositions/${id}/signature/init-sms`, {
    "telephoneNumber": phone
  });
}

export function signPropositionContract(jwt: string,id: string, data: ISignContract) {
  return collectiveAffiliationApi(jwt).post(`/propositions/${id}/signature/sign`, data);
}

export function validEmail(jwt: string, email: string) {
  let url = `/tools/emails/validate?email=${email}`
  return toolApi(jwt).get<IValidEmail>(url);
}

export function searchDqeAddress(jwt: string, addresse: string) {
  return toolApi(jwt).get<IDqeAdresseData[]>(`/tools/addresses/search?q=${addresse}`);
}

export function replaceDocument(jwt: string, id: string, documentId: string, file: File, toNotify = false, eventId?: string) {
  const formData = new FormData();
  formData.append('file', file);

  const headers = {
    'Content-Type': 'multipart/form-data'
  };

  let url = `/propositions/${id}/documents/${documentId}?toNotify=${toNotify}`;
  if(eventId) {
    url+=`&eventId=${eventId}`;
  }
  return collectiveAffiliationApi(jwt).patch(url, formData, {headers});
}

export function updatePropositionAfterSignature(jwt: string, id: string, data: IModificationDataAfterSignature) {
  return collectiveAffiliationApi(jwt).patch<IPropositionDetails>(`/propositions/${id}/post-signature/info`, data);
}

export function compressFile(jwt: string, file: File) {
  let formData = new FormData();
  formData.append('file', file);
 
  return toolApi(jwt, 'application/octet-stream').post('/tools/documents/compress', formData, { responseType: 'blob' });
}

export function mergeFile(jwt: string, files: File[]) {
  const formData = new FormData();

  files.forEach(file => {
    formData.append('files', file);
  })

  return toolApi(jwt, 'application/pdf').post('/tools/documents/merge', formData, {
    responseType: 'blob',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export function deleteDocument(jwt: string, id: string, documentId: string | undefined) {
  return collectiveAffiliationApi(jwt, 'application/octet-stream').delete(`/propositions/${id}/documents/${documentId}`);
}

export function validateInvalidDocument(jwt: string, id: string, documentId: string) {
  return collectiveAffiliationApi(jwt).patch<any>(`/propositions/${id}/documents/${documentId}/validate`);
}
export function upsaleStudies(jwt: string,id: string) {
  return collectiveAffiliationApi(jwt).post(`/propositions/${id}/upsale-studies`);
}

export function collectOffersRetired(jwt: string, data: IRERequestDataOffers) {
  return collectiveAffiliationApi(jwt).post<IOffers>(`/propositions/retired/${DEFAULT_CONTRACT_ID}/offers`, data);
}

export function collectOffers(jwt: string, data: ISimulateOffers) {
  return tarificationApi(jwt).post<IOffersDetails>(`/simulations/active-agent/simulate`, data);
}

export function createRetirementProposition(jwt: string, data: IRequestDataCreateRetirementProposition) {
  return collectiveAffiliationApi(jwt).post<IPropositionDetails>(`/propositions/retired/`, data);
}

export function lockRetirementProposition(jwt: string, id: string, data: IUpdatedProposition) {
  return collectiveAffiliationApi(jwt).post<IPropositionDetails>(`/propositions/retired/${id}/subscriptions/lock`, data);
}

export function validateBirthDate(id: string, birthDate: string) {
  return collectiveAffiliationApiWithoutToken().post(`/propositions/${id}/subscriptions/verify`, {
    birthDate
  });
}

export function subscriptionSearchProposition(data: ISubscriptionInfo) {
  return collectiveAffiliationApiWithoutToken().post(`/propositions/search`, data);
}

export function subscriptionSearchPropositionV2 (data: ISubscriptionInfoV2) {
  return collectiveAffiliationApiWithoutTokenV2().post(`/propositions/search`, data);
}

export function subscriptionGetAccessToken(jwt: string, propositionId: string, data: ISubscriptionAccessCode) {
    const headers = new Map([
    ['X-Application-Id', "EA"], ['Authorization', `Bearer ${jwt}`]
  ]);
  return collectiveAffiliationApi(jwt).post(`/propositions/${propositionId}/subscriptions/access-code`, data);
}

export function subscriptionConfirmEmailCode(jwt: string, propositionid: string, data: ISubscriptionConfirmEmailCode) {
  return collectiveAffiliationApi(jwt).post(`/propositions/${propositionid}/subscriptions/confirm-email-code`, data);
}

export function subscriptionSendLinkToEmail(jwt: string, propositionid: string, data: ISubscriptionSendLinkData) {
  return collectiveAffiliationApi(jwt).post(`/propositions/${propositionid}/subscriptions/send-link`, data);
}

export function subscriptionSendLinkCreateAccountToEmail(jwt: string, cacheId: string, propositionid: string, data: ISubscriptionSendLinkCreateAccountData) {
  return collectiveAffiliationApi(jwt, 'application/json', cacheId).post(`/propositions/${propositionid}/subscriptions/contact-info`, data);
}
